import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux';
import {store, AppState} from 'store/customer/storeSetup';

const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
const useAppDispatch = () => useDispatch<typeof store.dispatch>();

export {useAppSelector, useAppDispatch, store};
